import React, { useEffect, useMemo } from 'react';
import { Card } from '../Card';
import { Heading } from '../Heading';
import { Flex, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

const { Text } = Typography;

//  Define the Props interface
interface PackageSizeOrderCardProps {
  size: string;
  description?: string;
  isFragile: boolean;
  // isIdCheck?: boolean;
  // isClue?: boolean;
}

//  Update the component to accept props
const PackageSizeOrderCard: React.FC<PackageSizeOrderCardProps> = ({
  size,
  description,
  isFragile,
  // isClue,
  // isIdCheck,
}) => {
  const { t } = useTranslation();

  const getYesOrNo = (value?: boolean) => {
    return value ? t('yes') : t('no');
  };

  // const booleanItems = [
  //   // TODO: this file needs refactoring
  //   {
  //     title: t('fragile'),
  //     value: isFragile,
  //   },
  //   // {
  //   //   title: t('id_checked'),
  //   //   value: isIdCheck ? isIdCheck : undefined,
  //   // },
  //   // {
  //   //   title: t('clue_verification'),
  //   //   value: isClue ? isClue : undefined,
  //   // },
  // ];
  // const activeItems: {
  //   title: string;
  //   value?: boolean;
  // }[] = useMemo(
  //   () => booleanItems.flatMap((item) => (item.value !== undefined ? item : [])),
  //   [
  //     isFragile,
  //     //  isClue, isIdCheck
  //   ],
  // );

  return (
    <Card extraClassName='!shadow-card-dark mb-4'>
      <Heading
        title={t('package_size')} // Use the title prop
        fontSize='text-lg'
        fontWeight='font-bold'
        extraClassName='uppercase'
      />
      <Flex className={`justify-between  w-[50%] `}>
        <Flex vertical className='mt-[17px]'>
          <Text className=' capitalize font-normal text-sm leading-[18.2px] text-customGrayShade5'>
            {t(size)} {/* Use the size prop */}
          </Text>
          <Text className=' font-normal text-base leading-[20.48px] text-customTunaPrimary'>
            {description} {/* Use the description prop */}
          </Text>
        </Flex>
        <Flex vertical>
          <Heading
            title={t('fragile')}
            fontSize='text-sm'
            fontWeight='font-normal'
            color='text-customGrayShade5'
          />
          <Heading title={getYesOrNo(isFragile)} fontSize='text-sm' fontWeight='font-normal' />
        </Flex>
      </Flex>
    </Card>
  );
};

export default PackageSizeOrderCard;
